(function($){
  $('.vendor_list .vendor_list_alph').click(function(){
    if($(this).next('ul').css('display') == 'block') {
      $(this).next('ul').hide({done: $(this).css('display','')});
      $(this).children('.vendor_arrow').removeClass('open');
    } else {
      $(this).next('ul').show();
      $(this).children('.vendor_arrow').addClass('open');
    }
    
    $('.vendor_list ul').not($(this).next('ul')).hide({done: $(this).css('display','')});
    $('.vendor_list .vendor_list_alph').not($(this)).children('.vendor_arrow').removeClass('open');
  });
})(jQuery);